import { Dict } from '../../../../model/dict';
import { TreeMapNode } from '../../../../modules/diagram/components/tree-map-diagram/data/tree-map-node';
import { EmissionNode } from '../../../../public/dashboard/components/dashboard-emissions/emission-node';
import { EmissionScenarioItem } from '../emission-data/emission-scenario-item';
import { colourForEmissionNodeV42 } from './colour-for-emission-node-v42';
import { ActivityTree } from './create-activity-tree';

export function createEmissionNodes(
  activityTree: ActivityTree,
  scenarioStartYear: number,
  emissionScenarioData: Dict<{ [year: string]: EmissionScenarioItem }>,
  labelFormatter: (value: number, totalValue: number) => string
): Dict<EmissionNode & TreeMapNode> {
  const allGroups = Object.values(activityTree.groups);
  const getParentId = (id: string) => {
    const group = allGroups.find((group) => group.children.includes(id));
    return group?.id ?? activityTree.id;
  };
  const emissionNodeList: EmissionNode[] = Object.values(activityTree.groups).map((group) => {
    return {
      title: group.title,
      id: group.id ?? '',
      colours: colourForEmissionNodeV42(group.colour),
      childNodes: structuredClone(group.children),
      story: group.story,
    };
  });
  return emissionNodeList.reduce((acc: Dict<EmissionNode & TreeMapNode>, group) => {
    const parentId = getParentId(group.id);
    const parentValue = emissionScenarioData[parentId]?.[scenarioStartYear]?.scenarioEmissions ?? 0;
    const colours = group.colours;
    const value = emissionScenarioData[group.id]?.[scenarioStartYear]?.scenarioEmissions ?? 0;
    acc[group.id] = {
      ...group,
      value,
      valueLabel: labelFormatter(value, parentValue),
      label: group.title,
      backgroundColours: {
        main: colours.main,
        highlight: colours.light,
      },
    };
    return acc;
  }, {});
}
